import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Attach Bearer Token
instance.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const token = user.token;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Handle auth errors
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Allow individual requests to opt-out of the redirect (e.g. secondary data fetches)
      if (!error.config?.skipRedirect) {
        const currentPath = window.location.pathname;
        if (currentPath !== '/login' && currentPath !== '/forgot-password' && currentPath !== '/reset-password') {
          localStorage.removeItem('user');
          window.location.href = '/login';
        }
      }
    }

    if (error.response?.status === 403) {
      console.error('Access denied:', error.response.data?.error);
    }

    return Promise.reject(error);
  }
);

export default instance;
